import { useMutation } from '@tanstack/react-query'

import { replaceVariant } from '../api'

const useReplaceVariantMutation = () => {
  return useMutation({ mutationFn: replaceVariant })
}

export default useReplaceVariantMutation
